import { getField, updateField } from 'vuex-map-fields'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { axiosKomship } from '@/store/helpers'

export default {
  components: {
    ToastificationContent,
  },
  namespaced: true,
  state: {
    expedition: [],
    listTicketType: [],
    productCategory: [],
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    UPDATE_EXPEDITION(state, data) {
      state.expedition = data
    },
    UPDATE_LIST_TICKET_TYPE(state, data) {
      state.listTicketType = data
    },
    UPDATE_PRODUCT_CATEGORY(state, data) {
      state.productCategory = data
    },
  },
  actions: {
    async init({ dispatch }) {
      dispatch('getUpdateExpedition')
      dispatch('getUpdateListTicketType')
      dispatch('getUpdateProductCategory')
    },
    async getUpdateExpedition({ commit, rootState }) {
      try {
        const response = await axiosKomship().get(
          'v2/shipments',
        )
        commit('UPDATE_EXPEDITION', response.data.data)
      } catch (err) {
        console.error(err)
      }
    },
    async getUpdateListTicketType({ commit, rootState }) {
      try {
        const response = await axiosKomship().get(
          '/v1/ticket-partner/ticket-type/list',
        )
        for (let x = 0; x < response.data.data.length; x += 1) {
          Object.assign(response.data.data[x], { onCheck: false })
        }
        commit('UPDATE_LIST_TICKET_TYPE', response.data.data)
      } catch (err) {
        console.error(err)
      }
    },
    async getUpdateProductCategory({ commit, rootState }) {
      try {
        const response = await axiosKomship().get(
          '/v1/product/category',
        )
        commit('UPDATE_PRODUCT_CATEGORY', response.data.data)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
